<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >Python发布申请</va-card-title
        >
        <va-card-content>
            <div>
                <div>
                    <vxe-form :data="toolbar.formData">
                        <vxe-form-item title="虚拟机" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    style="width: 100px"
                                    v-model="data.selectMac"
                                    :options="toolbar.macOptions"
                                    placeholder="全部"
                                    clearable
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="状态" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.status"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                    <vxe-option
                                        value="0"
                                        label="未提交"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="审批中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="已审批"
                                    ></vxe-option>
                                    <vxe-option
                                        value="3"
                                        label="已驳回"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="发布阶段" :item-render="{}">
                            <template #default="{ data }">
                                <vxe-select
                                    v-model="data.pubstatus"
                                    placeholder="全部"
                                    clearable
                                    style="width: 100px"
                                >
                                    <vxe-option
                                        value="1"
                                        label="测试发布"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="生产发布"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="关键字"
                            field="searchKey"
                            :item-render="{}"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.searchKey"
                                    placeholder="请输入项目ID、项目名称、业务人员"
                                    clearable
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item>
                            <template #default>
                                <vxe-button
                                    status="primary"
                                    @click="findData"
                                    @keyup.enter="findData"
                                    >查询</vxe-button
                                >
                                <vxe-button @click="clear">重置</vxe-button>
                                <vxe-button status="success" @click="addPublish"
                                    >新增</vxe-button
                                >
                                <vxe-button @click="exportDataEvent"
                                    >导出</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </div>
                <div style="overflow: hidden; height: 100%">
                    <vxe-table
                        stripe
                        class="mytable-scrollbar"
                        :data="tableData"
                        ref="xTable1"
                        :height="tableHeight"
                        show-overflow
                        :row-config="{
                            height: 36,
                            isHover: true,
                            isCurrent: true,
                        }"
                    >
                        <vxe-column
                            type="seq"
                            field="Id"
                            title="序号"
                            width="50"
                        ></vxe-column>
                        <vxe-column title="删除" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-trash-o"
                                    @click="removeRowEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="修改"
                            width="50"
                            :visible="isShowEditRow"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-pencil-square"
                                    @click="editAdminEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column title="编辑" width="50" show-overflow>
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-edit"
                                    @click="editRowEvent(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="更新包"
                            align="center"
                            width="70"
                            show-overflow
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-upload"
                                    @click="updatePackage(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            title="虚拟环境"
                            align="center"
                            width="80"
                            show-overflow
                            :visible="isShowEditRow"
                        >
                            <template #default="{ row }">
                                <vxe-button
                                    type="text"
                                    icon="fa fa-retweet"
                                    @click="creatEnv(row)"
                                ></vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column align="center" title="状态" width="100">
                            <template #default="{ row }">
                                <vxe-button
                                    v-bind:class="{
                                        active: row.AuditStatus === '已审批',
                                        error: row.AuditStatus === '已驳回',
                                    }"
                                    type="text"
                                    @click="showAuditList(row)"
                                    >{{ row.AuditStatus }}
                                </vxe-button>
                            </template>
                        </vxe-column>
                        <vxe-column
                            field="PubState"
                            title="发布阶段"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="projectID"
                            title="项目ID"
                            width="140"
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="projectName"
                            title="项目名称"
                            width="250"
                            show-overflow
                            resizable
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="UserName"
                            title="业务人员"
                            width="100"
                            show-overflow
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="DevelopUser"
                            title="开发人员"
                            width="140"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="CoeTeacher"
                            title="COE导师"
                            width="100"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="CreationTime"
                            title="申请时间"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="AuditTime"
                            title="审批时间"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="MachineName"
                            title="虚拟机"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ManSingleTime"
                            title="人工单次耗时(分钟)"
                            width="180"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ManFrequency"
                            title="人工执行频次(每月)"
                            width="180"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ManParticitant"
                            title="人工单次参与人数"
                            width="160"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="ManYearUse"
                            title="人工全年预计耗时(分钟)"
                            width="200"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="DevelopTime"
                            title="项目开发时间(小时)"
                            width="180"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="RobotType"
                            title="机器人类型"
                            width="120"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="RobotFrequency"
                            title="机器执行频率"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="RobotSingleTime"
                            title="机器单次运行时长(分钟)"
                            width="200"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="RobotMonthRun"
                            title="机器月运行次数"
                            width="140"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="RobotYearUse"
                            title="机器年总运行时长(分钟)"
                            width="200"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="Levele"
                            title="优先级"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="CreateMan"
                            title="创建人"
                            width="100"
                            sortable
                        ></vxe-column>
                        <vxe-column
                            field="CreateManEmail"
                            title="创建人邮箱"
                            width="180"
                            sortable
                            show-overflow
                        ></vxe-column>
                        <vxe-column
                            field="remark"
                            title="备注"
                            show-overflow
                            width="100"
                            sortable
                        ></vxe-column>
                    </vxe-table>
                </div>
                <div>
                    <vxe-pager
                        background
                        v-model:current-page="tablePager.currentPage"
                        v-model:page-size="tablePager.pageSize"
                        :total="tablePager.totalResult"
                        :page-sizes="[
                            10,
                            20,
                            100,
                            200,
                            { label: '全部数据', value: 10000 },
                        ]"
                        @page-change="handlePageChange"
                        :layouts="[
                            'PrevJump',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                            'NextJump',
                            'Sizes',
                            'FullJump',
                            'Total',
                        ]"
                    >
                    </vxe-pager>
                </div>
            </div>

            <vxe-modal
                v-model="formInput.isShow"
                @close="closeWinEvent"
                :title="formInput.title"
                width="840"
                height="600"
                show-zoom
                resize
                remember
            >
                <template #default>
                    <vxe-form
                        :data="formInput.formData"
                        :rules="formInput.formRules"
                        title-align="right"
                        ref="rForm"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="基本信息"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-address-card-o' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="项目ID"
                            field="projectID"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.projectID"
                                    placeholder="请输入项目ID"
                                    :disabled="formInput.allInputDisable"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button
                                    @click="selectReqs()"
                                    :disabled="formInput.allInputDisable"
                                    >选择
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="项目名称"
                            field="projectName"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.projectName"
                                    readonly
                                    placeholder="请输入项目名称"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="开发人员"
                            field="DevelopUser"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.DevelopUser"
                                    placeholder="请输入开发人员"
                                    :disabled="
                                        formInput.allInputDisable ||
                                        formInput.formData.lockDevelper
                                    "
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button
                                    @click="selectUser(1)"
                                    :disabled="
                                        formInput.allInputDisable ||
                                        formInput.formData.lockDevelper
                                    "
                                    >选择
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="业务人员"
                            field="UserNameEmail"
                            span="10"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.UserNameEmail"
                                    readonly
                                    placeholder="请选择业务人员"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button
                                    @click="selectUser(2)"
                                    :disabled="formInput.allInputDisable"
                                    >选择</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="CoE导师"
                            field="CoeTeacher"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.CoeTeacher"
                                    clearable
                                    placeholder="请输入CoE导师"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="发布阶段"
                            field="PubState"
                            span="12"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.PubState"
                                    @change="onSelectPubState"
                                    placeholder="请选择发布阶段"
                                    :disabled="formInput.allInputDisable"
                                    clearable
                                >
                                    <vxe-option
                                        value="1"
                                        label="测试发布"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="生产发布"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="备注"
                            field="remark"
                            span="24"
                            title-width="100px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.remark"
                                    clearable
                                    placeholder="请输入备注"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="生产发布填写"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-list-alt' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="人工单次耗时(分钟)"
                            field="ManSingleTime"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.ManSingleTime"
                                    placeholder="请输入人工单次耗时"
                                    @change="updateManYearUse"
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="人工执行频次(每月)"
                            field="ManFrequency"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.ManFrequency"
                                    placeholder="请输入人工执行频次"
                                    @change="updateManYearUse"
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="人工单次参与人数"
                            field="ManParticitant"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.ManParticitant"
                                    placeholder="请输入人工单次参与人数"
                                    @change="updateManYearUse"
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="人工全年预计耗时(分钟)"
                            field="ManYearUse"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.ManYearUse"
                                    placeholder="请输入人工全年预计耗时"
                                    disabled="true"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="项目开发时间(小时)"
                            field="DevelopTime"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.DevelopTime"
                                    placeholder="请输入项目开发时间"
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="机器人类型"
                            field="RobotType"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.RobotType"
                                    placeholder="请选择机器人类型"
                                    clearable
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                    @change="onSelectRobotType"
                                >
                                    <vxe-option
                                        value="1"
                                        label="有人值守"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="无人值守"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="机器执行频率"
                            field="RobotFrequency"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.RobotFrequency"
                                    placeholder="请选择机器执行频率"
                                    clearable
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                >
                                    <vxe-option
                                        value="1"
                                        label="每天"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="每周"
                                    ></vxe-option>
                                    <vxe-option
                                        value="3"
                                        label="每月"
                                    ></vxe-option>
                                    <vxe-option
                                        value="4"
                                        label="不定时"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="机器单次耗时(分钟)"
                            field="RobotSingleTime"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.RobotSingleTime"
                                    placeholder="请输入机器单次耗时"
                                    @change="updateRobotYearUse"
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="机器月运行次数"
                            field="RobotMonthRun"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.RobotMonthRun"
                                    placeholder="请输入机器月运行次数"
                                    @change="updateRobotYearUse"
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="机器年总运行时长(分钟)"
                            field="RobotYearUse"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    type="number"
                                    min="0"
                                    clearable
                                    v-model="formInput.formData.RobotYearUse"
                                    placeholder="请输入机器年总运行时长"
                                    disabled="true"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="定时执行时间"
                            field="ExecBegin"
                            span="12"
                            title-width="180px"
                        >
                            <template #default>
                                <vxe-input
                                    type="text"
                                    clearable
                                    v-model="formInput.formData.ExecBegin"
                                    placeholder="例:08:30"
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="-"
                            field="ExecEnd"
                            span="6"
                            title-width="30px"
                        >
                            <template #default>
                                <vxe-input
                                    type="text"
                                    clearable
                                    v-model="formInput.formData.ExecEnd"
                                    placeholder="例:17:30"
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                ></vxe-input>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="附件"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-paperclip' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="发布包"
                            field="fPathPackage"
                            span="18"
                            :item-render="{}"
                            title-width="100px"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.fPathPackage"
                                    placeholder="请选择发布包"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <template #default="">
                                <vxe-button
                                    :disabled="formInput.allInputDisable"
                                    @click="insertPackageEvent"
                                    >浏览</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="4" :item-render="{}">
                            <a
                                v-if="isShowPackageLink"
                                href="javascript:void(0);"
                                @click="downloadFile(1)"
                                >下载</a
                            >
                        </vxe-form-item>
                        <vxe-form-item
                            title="PPD"
                            field="fPathPpd"
                            span="18"
                            :item-render="{}"
                            title-width="100px"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.fPathPpd"
                                    placeholder="请选择PPD"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <template #default="">
                                <vxe-button
                                    :disabled="formInput.allInputDisable"
                                    @click="insertPPDEvent"
                                    >浏览</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <a
                                v-if="isShowPPDLink"
                                href="javascript:void(0);"
                                @click="downloadFile(2)"
                                >下载</a
                            >
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <a
                                v-if="!isShowPPDLink"
                                href="javascript:void(0);"
                                @click="downloadFile(4)"
                                >模板</a
                            >
                        </vxe-form-item>
                        <vxe-form-item
                            title="效果评估"
                            field="fPathResult"
                            span="18"
                            :item-render="{}"
                            title-width="100px"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.fPathResult"
                                    placeholder="请选择效果评估"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <template #default="">
                                <vxe-button
                                    @click="insertResultEvent"
                                    :disabled="
                                        !formInput.formData.isPro ||
                                        formInput.allInputDisable
                                    "
                                >
                                    浏览
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <a
                                v-if="isShowResultLink"
                                href="javascript:void(0);"
                                @click="downloadFile(3)"
                                >下载</a
                            >
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <a
                                v-if="!isShowResultLink"
                                href="javascript:void(0);"
                                @click="downloadFile(5)"
                                >模板</a
                            >
                        </vxe-form-item>
                        <vxe-form-item
                            span="24"
                            title-align="left"
                            title-width="600px"
                            :title-prefix="{ icon: 'fa fa-check-circle-o' }"
                            v-if="formInput.formData.AuditStatus == '2'"
                        >
                            <template #title>
                                <span style="color: red">审核意见</span>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="优先级"
                            field="Levele"
                            span="12"
                            title-width="100px"
                            v-if="formInput.formData.AuditStatus == '2'"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.Levele"
                                    placeholder="请选择优先级"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                >
                                    <vxe-option
                                        value="1"
                                        label="低"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="中"
                                    ></vxe-option>
                                    <vxe-option
                                        value="3"
                                        label="高"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="虚拟机"
                            field="MachineName"
                            span="12"
                            title-width="100px"
                            v-if="formInput.formData.AuditStatus == '2'"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.MachineName"
                                    :options="toolbar.macOptions"
                                    placeholder="请选择虚拟机"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="密钥加密"
                            field="IsEncrypt"
                            span="12"
                            title-width="100px"
                            v-if="formInput.formData.AuditStatus == '2'"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.IsEncrypt"
                                    placeholder="请选择密钥加密"
                                    clearable
                                    :disabled="formInput.allInputDisable"
                                >
                                    <vxe-option
                                        value="0"
                                        label="否"
                                    ></vxe-option>
                                    <vxe-option
                                        value="1"
                                        label="是"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            align="center"
                            span="24"
                            v-if="!formInput.saveButDisable"
                        >
                            <template #default>
                                <vxe-button
                                    :loading="submitting"
                                    @click="save('1')"
                                    icon="fa fa-save"
                                    status="success"
                                    >保存
                                </vxe-button>
                                <vxe-button
                                    :loading="submitting"
                                    @click="submit"
                                    icon="fa fa-check"
                                    status="primary"
                                    >提交
                                </vxe-button>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                </template>
            </vxe-modal>
            <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
                <template #default>
                    <div>
                        <vxe-form :data="userTablePager">
                            <vxe-form-item
                                title="关键字"
                                field="searchKey"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.searchKey"
                                        placeholder="请输入姓名或邮箱"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        @click="findUserData"
                                        @keyup.enter="findUserData"
                                        >查询</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        status="primary"
                                        @click="confirmSelectUser"
                                        >确定</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="24">
                                <template #title>
                                    <span>已选(</span
                                    ><span style="color: red">双击选择</span
                                    ><span>)</span>
                                </template>
                                <template #default>
                                    <div v-if="formInput.userSelType == 1">
                                        <template
                                            v-for="(item, index) in formInput
                                                .formData.DevelopIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                        </template>
                                    </div>
                                    <div v-else>
                                        <template
                                            v-for="(item, index) in formInput
                                                .formData.UserIDName"
                                            :key="index"
                                        >
                                            <span>{{ item.Name }}</span>
                                            <va-icon
                                                class="icon-left input-icon"
                                                @click="clearUser(item.ID)"
                                                name="clear"
                                            />
                                        </template>
                                    </div>
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="dtUser"
                            ref="xTableUser"
                            height="300"
                            @cell-dblclick="chooseUser"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="Uid"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="UserName"
                                title="姓名"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobZb"
                                title="总部"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="JobName"
                                title="部门"
                                width="120"
                                show-overflow
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="UserMail"
                                title="邮箱"
                                width="200"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="Id"
                                title="Id"
                                width="10"
                                :visible="false"
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="userTablePager.currentPage"
                            v-model:page-size="userTablePager.pageSize"
                            :total="userTablePager.totalResult"
                            @page-change="userListPageChange"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal
                title="审核记录"
                v-model="isShowAuditList"
                width="500"
                height="600"
            >
                <template #default>
                    <div>
                        <MyAuditLine :auditrecord-list="dtAudit"></MyAuditLine>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal title="更新包" v-model="packageForm.iShow" width="740">
                <template #default>
                    <div>
                        <vxe-form :data="packageForm">
                            <vxe-form-item
                                title="发布包"
                                field="packageName"
                                span="16"
                                :item-render="{}"
                                title-width="100px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="packageForm.packageName"
                                        placeholder="请选择发布包"
                                        readonly
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item title="" span="2" :item-render="{}">
                                <template #default="">
                                    <vxe-button
                                        :disabled="packageForm.isDisable"
                                        @click="insertUpdatePackageEvent"
                                    >
                                        浏览
                                    </vxe-button>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item title="" span="6" :item-render="{}">
                                <span style="color: red; margin-left: 10px"
                                    >一天最多上传{{
                                        packageForm.uploadTimes
                                    }}次</span
                                >
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="packageForm.dtPackage"
                            ref="xTableUser"
                            height="300"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="Id"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="url"
                                title="文件名"
                                width="200"
                                sortable
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="versioncode"
                                title="版本号"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="applytime"
                                title="上传时间"
                                width="140"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="IsUse"
                                title="是否在用"
                                width="100"
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                align="center"
                                title="使用此版本"
                                width="100"
                            >
                                <template #default="{ row }">
                                    <vxe-button
                                        type="text"
                                        @click="choosePackage(row)"
                                        >选择</vxe-button
                                    >
                                </template>
                            </vxe-column>
                            <vxe-column
                                field="Id"
                                title="Id"
                                width="10"
                                :visible="false"
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="
                                updatePackagePager.currentPage
                            "
                            v-model:page-size="updatePackagePager.pageSize"
                            :total="updatePackagePager.totalResult"
                            @page-change="updatePackageListPageChange"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                </template>
            </vxe-modal>
            <vxe-modal title="选择需求" v-model="isShowRequireSel" width="640">
                <template #default>
                    <div>
                        <vxe-form :data="reqTablePager">
                            <vxe-form-item
                                title="关键字"
                                field="searchKey"
                                :item-render="{}"
                            >
                                <template #default="{ data }">
                                    <vxe-input
                                        v-model="data.searchKey"
                                        placeholder="请输入需求编号、项目ID、项目名称"
                                        clearable
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        @click="findReqsData"
                                        @keyup.enter="findReqsData"
                                        >查询</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item>
                                <template #default>
                                    <vxe-button
                                        status="primary"
                                        @click="confirmSelectReq"
                                        >选择</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                    </div>
                    <div>
                        <vxe-table
                            class="mytable-scrollbar"
                            :data="dtReqs"
                            ref="xTableReqs"
                            height="300"
                            @cell-dblclick="confirmSelectReq"
                            highlight-hover-row
                            highlight-current-row
                        >
                            <vxe-column
                                type="seq"
                                field="Id"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="requireNo"
                                title="需求编号"
                                width="140"
                                resizable
                                sortable
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="projectName"
                                title="项目名称"
                                width="180"
                                show-overflow
                                resizable
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="projectID"
                                title="项目ID"
                                width="130"
                                sortable
                                show-overflow
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="projectDesc"
                                title="项目描述"
                                width="200"
                                show-overflow
                                resizable
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="bussName"
                                title="业务姓名"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="division"
                                title="总部"
                                width="100"
                                sortable
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="dept"
                                title="业务部门"
                                width="120"
                                resizable
                                sortable
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="office"
                                title="业务科室"
                                width="120"
                                sortable
                                show-overflow
                            ></vxe-column>
                            <vxe-column
                                field="winMan"
                                title="业务窗口"
                                width="100"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="leader"
                                title="业务科长"
                                width="100"
                                sortable
                            ></vxe-column>
                        </vxe-table>
                    </div>
                    <div>
                        <vxe-pager
                            background
                            v-model:current-page="reqTablePager.currentPage"
                            v-model:page-size="reqTablePager.pageSize"
                            :total="reqTablePager.totalResult"
                            @page-change="reqListPageChange"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                </template>
            </vxe-modal>
        </va-card-content>
    </va-card>
</template>

<script>
import Qs from "qs";
import { reactive, ref } from "vue";
import { VxeTablePropTypes } from "vxe-table";
import { VXETable } from "vxe-table";
import XEUtils from "xe-utils";
import MyAuditLine from "../myPlug/MyAuditLine";

export default {
    name: "PublishApplyPython",
    components: { MyAuditLine },
    data() {
        const pageHeight = window.innerHeight - (65 + 48 + 198) + "px"; //屏幕高度减去导航栏和内补白
        const tablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const userTablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
            searchKey: "",
        });
        const reqTablePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
            searchKey: "",
        });
        const updatePackagePager = reactive({
            currentPage: 1,
            pageSize: 10,
            totalResult: 0,
        });
        const toolbar = reactive({
            loading: false,
            macOptions: [],
            formData: {
                selectMac: "",
                status: "",
                pubstatus: "",
                runstatus: "",
                searchKey: "",
                dept: "",
            },
        });

        const packageForm = reactive({
            dtPackage: [],
            iShow: false, //显示更新包
            packageFile: {}, //更新包附件
            packageName: "",
            uploadTimes: 0, //可以上传次数
            selPublishId: "", //更新的ID
            isDisable: false,
        });

        const formInput = reactive({
            title: "新增发布申请",
            isShow: false,
            saveButDisable: false,
            allInputDisable: false,
            projectIDReadonly: true,
            userSelType: 1, //1 开发人员 2 业务人员
            isCheck: false,
            formData: {
                Id: "",
                AuditStatus: "0",
                projectID: "",
                projectName: "",
                UserName: "",
                UserNameEmail: "",
                UserId: "",
                UserIDName: [],
                DevelopUser: "",
                DevelopUserUID: "",
                DevelopIDName: [],
                CoeTeacher: "",
                PubState: "",
                ManSingleTime: "",
                ManFrequency: "",
                ManParticitant: "",
                ManYearUse: "",
                DevelopTime: "",
                RobotType: "1",
                RobotFrequency: "",
                RobotSingleTime: "",
                RobotMonthRun: "",
                RobotYearUse: "",
                Levele: "",
                MachineName: "",
                IsEncrypt: "",
                remark: "",
                fPathPackage: "",
                fPathPpd: "",
                fPathResult: "",
                ExecBegin: "",
                ExecEnd: "",
                isPro: false, //是否生产发布
                lockDevelper: true,
            },
            formRules: {
                projectID: [{ required: true, message: "项目ID不能为空" }],
                projectName: [{ required: true, message: "项目名称不能为空" }],
                DevelopUser: [{ required: true, message: "开发人员不能为空" }],
                UserNameEmail: [
                    { required: true, message: "业务人员不能为空" },
                ],
                RobotType: [{ required: false, message: "机器人类型不能为空" }],
                CoeTeacher: [{ required: true, message: "CoE导师不能为空" }],
                PubState: [{ required: true, message: "发布阶段不能为空" }],
                ManSingleTime: [
                    { required: false, message: "人工单次耗时不能为空" },
                ],
                ManFrequency: [
                    { required: false, message: "人工执行频次不能为空" },
                ],
                ManParticitant: [
                    { required: false, message: "人工单次参与人数不能为空" },
                ],
                ManYearUse: [
                    { required: false, message: "人工全年预计耗时不能为空" },
                ],
                DevelopTime: [
                    { required: false, message: "项目开发时间不能为空" },
                ],
                RobotFrequency: [
                    { required: false, message: "机器执行频率不能为空" },
                ],
                RobotSingleTime: [
                    { required: false, message: "机器单次耗时不能为空" },
                ],
                RobotMonthRun: [
                    { required: false, message: "机器月运行次数不能为空" },
                ],
                RobotYearUse: [
                    { required: false, message: "机器年总运行时长不能为空" },
                ],
                remark: [{ required: false, message: "备注不能为空" }],
                ExecBegin: [
                    { required: false, message: "定时执行开始时间不能为空" },
                ],
                ExecEnd: [
                    { required: false, message: "定时执行结束时间不能为空" },
                ],
                fPathPackage: [{ required: true, message: "发布包不能为空" }],
                fPathPpd: [{ required: true, message: "PPD不能为空" }],
                fPathResult: [{ required: false, message: "效果评估不能为空" }],
            },
        });
        return {
            tableData: null,
            tablePager,
            userTablePager,
            updatePackagePager,
            toolbar,
            pageHeight,
            formInput,
            dtUser: null,
            iShowSelectUser: ref(false),
            onePackageFile: {}, //上传的附件
            isShowPackageLink: false,
            onePPDFile: {}, //上传的附件
            isShowPPDLink: false,
            oneResultFile: {}, //上传的附件
            isShowResultLink: false,
            dtAudit: [],
            isShowAuditList: false,
            packageForm,
            isShowEditRow: false, //管理员编辑列
            isShowRequireSel: false, //发布申请，选择需求
            reqTablePager,
            dtReqs: [], //需求列表
            tableHeight: 0,
            submitting: false,
        };
    },
    methods: {
        calTableHeight(rowsLength) {
            let minHeight = window.innerHeight - (65 + 28 + 198);
            let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
            this.tableHeight = Math.max(minHeight, calHeight);
        },
        findData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.tablePager.currentPage,
                pageSize: this.tablePager.pageSize,
                searchKey: [
                    this.toolbar.formData.searchKey,
                    this.toolbar.formData.selectMac,
                    this.toolbar.formData.status,
                    this.toolbar.formData.pubstatus,
                    this.toolbar.formData.runstatus,
                ],
            };
            this.$api.publishManageAPI
                .getPublishListPython(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    // console.log(res.data.Data);
                    this.tableData = res.data.Data.dataTable;
                    this.tablePager.currentPage = res.data.Data.currentPage;
                    this.tablePager.pageSize = res.data.Data.pageSize;
                    this.tablePager.totalResult = res.data.Data.totalResult;
                    this.tableHeight = this.$calTableHeight(
                        res.data.Data.dataTable.length
                    );
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handlePageChange() {
            this.findData();
        },
        userListPageChange() {
            this.findUserData();
        },
        reqListPageChange() {
            this.findReqsData();
        },
        showAuditList(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: [row.Id], //
            };
            this.$api.requireManageAPI
                .getAuditRecordList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtAudit = res.data.Data;
                    this.isShowAuditList = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        addAuditRecord(status) {
            //写审核日志
            const params = {
                auditBuId: this.formInput.formData.Id,
                auditMan: this.$store.state.userName,
                auditManUid: this.$store.state.userID,
                auditStatus: status, //0发起 1 通过 2 驳回
                auditOpinion: "",
                auditNode: "审核发起",
            };
            this.$api.requireManageAPI
                .addAuditRecord(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        bindPC() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 1,
                searchKey: ["1"], //Python
            };
            this.$api.systemManageAPI
                .getMachineListByType(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    // console.log(res.data.Data);
                    this.toolbar.macOptions = [];
                    for (const item of res.data.Data) {
                        this.toolbar.macOptions.push({
                            value: item.RobotName,
                            label: item.Abbr,
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        clear() {
            this.toolbar.formData.searchKey = "";
            this.toolbar.formData.status = "";
            this.toolbar.formData.selectMac = "";
            this.toolbar.formData.pubstatus = "";
            this.toolbar.formData.runstatus = "";
        },
        //删除
        async removeRowEvent(row) {
            if (row.AuditStatus === "审批中" || row.AuditStatus === "已审批") {
                await VXETable.modal.message({
                    content: "审批中或已审批不能删除，请先驳回",
                    status: "error",
                });
                return;
            }

            const type = await VXETable.modal.confirm("您确定要删除该数据?");
            const $grid = this.$refs.xTable1;
            if (type === "confirm") {
                this.$api.publishManageAPI
                    .delPublishPython(
                        Qs.stringify({ publishId: row.Id, editType: "1" })
                    )
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        VXETable.modal.message({
                            content: "删除成功",
                            status: "success",
                        });

                        $grid.remove(row);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        //管理员修改
        editAdminEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 20,
                searchKey: [row.Id],
            };
            this.$api.publishManageAPI
                .getPublishOnePython(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }

                    this.formInput.formData = res.data.Data;
                    this.onSelectPubState();
                    if (this.formInput.formData.PubState === "1") {
                        this.isShowPackageLink = true;
                        this.isShowPPDLink = true;
                        this.isShowResultLink = false;
                    } else {
                        this.isShowPackageLink = true;
                        this.isShowPPDLink = true;
                        this.isShowResultLink = true;
                    }
                    this.formInput.formRules.fPathPackage[0].required = false;
                    this.formInput.formRules.fPathPpd[0].required = false;
                    this.formInput.formRules.fPathResult[0].required = false;
                    this.formInput.title = "管理员修改发布申请";
                    this.submitting = false;
                    this.editType = "3"; //更新

                    this.formInput.allInputDisable = false;
                    this.formInput.saveButDisable = false;
                    this.formInput.formData.lockDevelper = false;

                    this.formInput.formData.DevelopIDName = [];
                    this.formInput.formData.DevelopIDName.push({
                        Name: this.formInput.formData.DevelopUser,
                        ID: this.formInput.formData.DevelopUserUID,
                    });

                    let count =
                        this.formInput.formData.UserId.toString().split(
                            ";"
                        ).length;
                    this.formInput.formData.UserIDName = [];
                    for (let i = 0; i < count; i++) {
                        this.formInput.formData.UserIDName.push({
                            Name: this.formInput.formData.UserNameEmail.toString().split(
                                ";"
                            )[i],
                            ID: this.formInput.formData.UserId.toString().split(
                                ";"
                            )[i],
                        });
                    }
                    this.formInput.projectIDReadonly = false;
                    this.formInput.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //编辑数据
        editRowEvent(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 20,
                searchKey: [row.Id],
            };
            this.$api.publishManageAPI
                .getPublishOnePython(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success === false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }

                    this.formInput.formData = res.data.Data;
                    //console.log(res.data.Data)
                    this.formInput.formData.lockDevelper = true; //开发人员不能修改
                    this.onSelectPubState();
                    if (this.formInput.formData.PubState === "1") {
                        this.isShowPackageLink = true;
                        this.isShowPPDLink = true;
                        this.isShowResultLink = false;
                    } else {
                        this.isShowPackageLink = true;
                        this.isShowPPDLink = true;
                        this.isShowResultLink = true;
                    }
                    this.formInput.formRules.fPathPackage[0].required = false;
                    this.formInput.formRules.fPathPpd[0].required = false;
                    this.formInput.formRules.fPathResult[0].required = false;
                    this.formInput.title = "编辑发布申请";

                    this.editType = "2"; //更新
                    if (
                        this.formInput.formData.AuditStatus === "1" ||
                        this.formInput.formData.AuditStatus === "2"
                    ) {
                        this.formInput.allInputDisable = true;
                        this.formInput.saveButDisable = true;
                    } else {
                        this.formInput.allInputDisable = false;
                        this.formInput.saveButDisable = false;
                    }
                    this.formInput.formData.DevelopIDName = [];
                    this.formInput.formData.DevelopIDName.push({
                        Name: this.formInput.formData.DevelopUser,
                        ID: this.formInput.formData.DevelopUserUID,
                    });

                    let count =
                        this.formInput.formData.UserId.toString().split(
                            ";"
                        ).length;
                    this.formInput.formData.UserIDName = [];
                    for (let i = 0; i < count; i++) {
                        this.formInput.formData.UserIDName.push({
                            Name: this.formInput.formData.UserNameEmail.toString().split(
                                ";"
                            )[i],
                            ID: this.formInput.formData.UserId.toString().split(
                                ";"
                            )[i],
                        });
                    }
                    this.formInput.projectIDReadonly = true;
                    this.formInput.isShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //更新发布包
        updatePackage(row) {
            this.updatePackagePager.currentPage = 1;
            this.updatePackagePager.pageSize = 10;
            this.packageForm.selPublishId = row.Id;
            this.packageForm.packageName = "";
            this.packageForm.packageFile = {};
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.updatePackagePager.currentPage,
                pageSize: this.updatePackagePager.pageSize,
                searchKey: [this.packageForm.selPublishId],
            };

            this.$api.publishManageAPI
                .getPackageListPython(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.packageForm.dtPackage = res.data.Data.dataTable;
                    this.updatePackagePager.currentPage =
                        res.data.Data.currentPage;
                    this.updatePackagePager.pageSize = res.data.Data.pageSize;
                    this.updatePackagePager.totalResult =
                        res.data.Data.totalResult;
                    this.packageForm.iShow = true;
                })
                .catch((error) => {
                    console.log(error);
                });

            this.$api.publishManageAPI
                .getPackageUpdateCount(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.packageForm.uploadTimes = res.data.Data.totalCount;
                    if (res.data.Data.remainCount <= 0) {
                        this.packageForm.isDisable = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        //使用版本
        choosePackage(row) {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: "",
                pageSize: "",
                searchKey: [this.packageForm.selPublishId, row.versioncode],
            };

            this.$api.publishManageAPI
                .updatePackageVersionPython(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    VXETable.modal.message({
                        content:
                            "更新成功，如果有虚拟环境，请等待创建虚拟环境成功邮件再执行项目",
                        status: "success",
                    });
                    this.findPackageData();
                    this.$api.publishManageAPI
                        .getPackageUpdateCount(Qs.stringify(params))
                        .then((res) => {
                            if (res.data.Success == false) {
                                VXETable.modal.message({
                                    content: res.data.Message,
                                    status: "error",
                                });
                                return;
                            }
                            // console.log(res.data.Data);
                            this.packageForm.uploadTimes =
                                res.data.Data.totalCount;
                            if (res.data.Data.remainCount <= 0) {
                                this.packageForm.isDisable = true;
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        closeWinEvent() {
            this.findData();
        },
        //新增
        async addPublish() {
            this.formInput.formData = {
                Id: this.$utils.guid(),
                AuditStatus: "0",
                projectID: "",
                projectName: "",
                UserName: "",
                UserId: "",
                DevelopUser: this.$store.state.userName,
                DevelopUserUID: this.$store.state.Id,
                CoeTeacher: "",
                PubState: "",
                ManSingleTime: "",
                ManFrequency: "",
                ManParticitant: "",
                ManYearUse: "",
                DevelopTime: "",
                RobotType: "1",
                RobotFrequency: "",
                RobotSingleTime: "",
                RobotMonthRun: "",
                RobotYearUse: "",
                remark: "",
                fPathPackage: "",
                fPathPpd: "",
                fPathResult: "",
                ExecBegin: "",
                ExecEnd: "",
                isPro: false, //是否生产发布
                lockDevelper: true,
            };
            this.editType = "1"; //新增
            this.formInput.projectIDReadonly = true;
            this.formInput.isShow = true;
            this.oneResultFile = {};
            this.onePPDFile = {};
            this.onePackageFile = {};
            this.submitting = false;
            this.isShowPackageLink = false;
            this.isShowPPDLink = false;
            this.isShowResultLink = false;
            this.formInput.formRules.fPathResult[0].required = false;
            this.formInput.formRules.ManSingleTime[0].required = false;
            this.formInput.formRules.ManFrequency[0].required = false;
            this.formInput.formRules.ManParticitant[0].required = false;
            this.formInput.formRules.ManYearUse[0].required = false;
            this.formInput.formRules.DevelopTime[0].required = false;
            this.formInput.formRules.RobotType[0].required = false;
            this.formInput.formRules.RobotFrequency[0].required = false;
            this.formInput.formRules.RobotSingleTime[0].required = false;
            this.formInput.formRules.RobotMonthRun[0].required = false;
            this.formInput.formRules.RobotYearUse[0].required = false;
            this.formInput.formRules.ExecBegin[0].required = false;
            this.formInput.formRules.ExecEnd[0].required = false;
            this.formInput.formRules.fPathPackage[0].required = false;
            this.formInput.formRules.fPathPpd[0].required = false;
            this.formInput.allInputDisable = false;
            this.formInput.saveButDisable = false;
            this.formInput.formData.isPro = false;
            this.formInput.title = "新增发布申请";
            const $rForm = this.$refs.rForm;
            try {
                const re = await $rForm.clearValidate();
            } catch (e) {
                console.log(e);
            }
        },
        selectUser(type) {
            this.formInput.userSelType = type;
            this.findUserData();
            this.iShowSelectUser = true;
        },
        selectReqs() {
            this.findReqsData();
            this.isShowRequireSel = true;
        },
        findReqsData() {
            const findStat = "2"; //全部
            const devEmail = this.formInput.projectIDReadonly
                ? this.$store.state.email
                : "";
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.reqTablePager.currentPage,
                pageSize: this.reqTablePager.pageSize,
                searchKey: [
                    this.reqTablePager.searchKey,
                    findStat,
                    "4",
                    devEmail,
                ], //第4个参数，是按开发人员查询
            };
            this.$api.requireManageAPI
                .getRequireListPython(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });

                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtReqs = res.data.Data.dataTable;
                    this.reqTablePager.currentPage = res.data.Data.currentPage;
                    this.reqTablePager.pageSize = res.data.Data.pageSize;
                    this.reqTablePager.totalResult = res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        confirmSelectUser() {
            this.iShowSelectUser = false;
        },
        confirmSelectReq() {
            const $table = this.$refs.xTableReqs;
            const record = $table.getCurrentRecord();
            if (record == null || record.length == 0) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }
            this.formInput.formData.projectID = record.projectID;
            this.formInput.formData.projectName = record.projectName;
            this.isShowRequireSel = false;
        },
        //删除用户
        clearUser(userid) {
            let idx = -1;
            this.formInput.formData.UserIDName.forEach(function (
                item,
                index,
                arr
            ) {
                if (item.ID == userid) {
                    idx = index;
                }
            });
            let tmpId = [],
                tmpname = [];
            tmpId = this.formInput.formData.UserId.toString().split(";");
            tmpname =
                this.formInput.formData.UserNameEmail.toString().split(";");
            tmpId.splice(idx, 1);
            tmpname.splice(idx, 1);
            this.formInput.formData.UserId = tmpId.join(";");
            this.formInput.formData.UserNameEmail = tmpname.join(";");
            let count = 0;
            if (this.formInput.formData.UserId.toString() != "") {
                count =
                    this.formInput.formData.UserId.toString().split(";").length;
            }
            this.formInput.formData.UserIDName = [];
            //debugger
            for (let i = 0; i < count; i++) {
                this.formInput.formData.UserIDName.push({
                    Name: this.formInput.formData.UserNameEmail.toString().split(
                        ";"
                    )[i],
                    ID: this.formInput.formData.UserId.toString().split(";")[i],
                });
            }
        },
        //选择用户
        chooseUser() {
            const $table = this.$refs.xTableUser;
            const record = $table.getCurrentRecord();
            if (record == null || record.length == 0) {
                VXETable.modal.message({
                    content: "请选择一行数据",
                    status: "info",
                });
                return;
            }
            //选开发人员
            if (this.formInput.userSelType == 1) {
                this.formInput.formData.DevelopUser =
                    record.UserName + "(" + record.UserMail + ")";
                this.formInput.formData.DevelopUserUID = record.Id;
                this.formInput.formData.DevelopIDName = [];
                this.formInput.formData.DevelopIDName.push({
                    Name: this.formInput.formData.DevelopUser,
                    ID: this.formInput.formData.DevelopUserUID,
                });

                //选业务人员
            } else {
                //判断是否已选择过
                if (this.formInput.formData.UserId.toString() != "") {
                    for (let item of this.formInput.formData.UserId.toString().split(
                        ";"
                    )) {
                        if (item == record.Id) {
                            VXETable.modal.message({
                                content: "该人员已选择",
                                status: "warning",
                            });
                            return;
                        }
                    }
                }

                if (
                    this.formInput.formData.UserNameEmail == null ||
                    this.formInput.formData.UserNameEmail == ""
                ) {
                    this.formInput.formData.UserNameEmail =
                        record.UserName + "(" + record.UserMail + ")";
                } else {
                    this.formInput.formData.UserNameEmail +=
                        ";" + record.UserName + "(" + record.UserMail + ")";
                }

                if (
                    this.formInput.formData.UserId == null ||
                    this.formInput.formData.UserId == ""
                ) {
                    this.formInput.formData.UserId = record.Id;
                } else {
                    this.formInput.formData.UserId += ";" + record.Id;
                }

                let count =
                    this.formInput.formData.UserId.toString().split(";").length;
                this.formInput.formData.UserIDName = [];
                for (let i = 0; i < count; i++) {
                    this.formInput.formData.UserIDName.push({
                        Name: this.formInput.formData.UserNameEmail.toString().split(
                            ";"
                        )[i],
                        ID: this.formInput.formData.UserId.toString().split(
                            ";"
                        )[i],
                    });
                }
            }
        },
        //保存现磨
        async save() {
            const $rForm = this.$refs.rForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                return;
            }
            if (this.formInput.formData.fPathPackage === "") {
                await VXETable.modal.message({
                    content: "发布包不能为空",
                    status: "warning",
                });
                return;
            }
            if (this.formInput.formData.fPathPpd === "") {
                await VXETable.modal.message({
                    content: "PPD不能为空",
                    status: "warning",
                });
                return;
            }
            if (
                this.formInput.formData.isPro &&
                this.formInput.formData.fPathResult === ""
            ) {
                await VXETable.modal.message({
                    content: "效果评估不能为空",
                    status: "warning",
                });
                return;
            }
            const data = this.getModel();
            this.submitting = true;
            //新增
            if (this.editType === "1") {
                this.$api.publishManageAPI
                    .addPublishPython(data)
                    .then((res) => {
                        if (res.data.Success == false) {
                            this.submitting = false;
                            VXETable.modal.alert({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        this.editType = "2"; //新增后是修改
                        if (res.data.Message == "1") {
                            this.isShowPackageLink = true;
                            this.isShowPPDLink = false;
                            this.isShowResultLink = false;
                        } else if (res.data.Message == "2") {
                            this.isShowPackageLink = true;
                            this.isShowPPDLink = true;
                            this.isShowResultLink = false;
                        } else if (res.data.Message == "3") {
                            this.isShowPackageLink = true;
                            this.isShowPPDLink = true;
                            this.isShowResultLink = true;
                        }
                        this.formInput.formRules.fPathPackage[0].required = false;
                        this.formInput.formRules.fPathPpd[0].required = false;
                        this.formInput.formRules.fPathResult[0].required = false;
                        this.submitting = false;
                        VXETable.modal.message({
                            content: "保存成功",
                            status: "success",
                        });
                    })
                    .catch((error) => {
                        this.submitting = false;
                        VXETable.modal.alert({
                            content: error,
                            status: "error",
                        });
                        console.log(error);
                    });
            } else if (this.editType === "2") {
                //更新
                this.$api.publishManageAPI
                    .updatePublishPython(data)
                    .then((res) => {
                        if (res.data.Success == false) {
                            this.submitting = false;
                            VXETable.modal.alert({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        if (this.formInput.formData.PubState == "1") {
                            this.isShowPackageLink = true;
                            this.isShowPPDLink = true;
                            this.isShowResultLink = false;
                        } else {
                            this.isShowPackageLink = true;
                            this.isShowPPDLink = true;
                            this.isShowResultLink = true;
                        }

                        this.formInput.formRules.fPathPackage[0].required = false;
                        this.formInput.formRules.fPathPpd[0].required = false;
                        this.formInput.formRules.fPathResult[0].required = false;
                        this.editType = "2"; //
                        this.submitting = false;
                        VXETable.modal.message({
                            content: "保存成功",
                            status: "success",
                        });
                    })
                    .catch((error) => {
                        this.submitting = false;
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        console.log(error);
                    });
            } else if (this.editType === "3") {
                //管理员修改
                this.$api.publishManageAPI
                    .updateAdminPublishPython(data)
                    .then((res) => {
                        if (res.data.Success == false) {
                            this.submitting = false;
                            VXETable.modal.alert({
                                content: res.data.Message,
                                status: "error",
                            });
                            return;
                        }
                        if (this.formInput.formData.PubState == "1") {
                            this.isShowPackageLink = true;
                            this.isShowPPDLink = true;
                            this.isShowResultLink = false;
                        } else {
                            this.isShowPackageLink = true;
                            this.isShowPPDLink = true;
                            this.isShowResultLink = true;
                        }
                        this.formInput.formRules.fPathPackage[0].required = false;
                        this.formInput.formRules.fPathPpd[0].required = false;
                        this.formInput.formRules.fPathResult[0].required = false;
                        this.editType = "3"; //
                        this.submitting = false;
                        VXETable.modal.message({
                            content: "保存成功",
                            status: "success",
                        });
                    })
                    .catch((error) => {
                        this.submitting = false;
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        console.log(error);
                    });
            }
        },
        getModel() {
            const data = new FormData();
            data.append("filePackage", this.onePackageFile);
            data.append("filePpd", this.onePPDFile);
            data.append("fileResult", this.oneResultFile);
            data.append("Id", this.formInput.formData.Id);
            data.append("fPathPackage", this.formInput.formData.fPathPackage);
            data.append("fPathPpd", this.formInput.formData.fPathPpd);
            data.append("fPathResult", this.formInput.formData.fPathResult);
            data.append("projectID", this.formInput.formData.projectID);
            data.append("projectName", this.formInput.formData.projectName);
            data.append("AuditStatus", this.formInput.formData.AuditStatus);
            data.append("UserId", this.formInput.formData.UserId);
            data.append("DevelopUser", this.formInput.formData.DevelopUser);
            data.append(
                "DevelopUserUID",
                this.formInput.formData.DevelopUserUID
            );
            data.append("CoeTeacher", this.formInput.formData.CoeTeacher);
            data.append("PubState", this.formInput.formData.PubState);
            data.append("ManSingleTime", this.formInput.formData.ManSingleTime);
            data.append("ManFrequency", this.formInput.formData.ManFrequency);
            data.append(
                "ManParticitant",
                this.formInput.formData.ManParticitant
            );
            data.append("ManYearUse", this.formInput.formData.ManYearUse);
            data.append("DevelopTime", this.formInput.formData.DevelopTime);
            data.append("RobotType", this.formInput.formData.RobotType);
            data.append(
                "RobotFrequency",
                this.formInput.formData.RobotFrequency
            );
            data.append(
                "RobotSingleTime",
                this.formInput.formData.RobotSingleTime
            );
            data.append("RobotMonthRun", this.formInput.formData.RobotMonthRun);
            data.append("RobotYearUse", this.formInput.formData.RobotYearUse);
            data.append("remark", this.formInput.formData.remark);
            data.append("createUserId", this.$store.state.userID);
            data.append("ExecBegin", this.formInput.formData.ExecBegin);
            data.append("ExecEnd", this.formInput.formData.ExecEnd);
            data.append("Levele", this.formInput.formData.Levele);
            data.append("MachineName", this.formInput.formData.MachineName);
            data.append("IsEncrypt", this.formInput.formData.IsEncrypt);

            return data;
        },
        findUserData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.userTablePager.currentPage,
                pageSize: this.userTablePager.pageSize,
                searchKey: [this.userTablePager.searchKey],
            };
            this.$api.systemManageAPI
                .getUserList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.dtUser = res.data.Data.dataTable;
                    this.userTablePager.currentPage = res.data.Data.currentPage;
                    this.userTablePager.pageSize = res.data.Data.pageSize;
                    this.userTablePager.totalResult = res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updatePackageListPageChange() {
            this.findPackageData();
        },
        findPackageData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: this.updatePackagePager.currentPage,
                pageSize: this.updatePackagePager.pageSize,
                searchKey: [this.packageForm.selPublishId],
            };
            this.$api.publishManageAPI
                .getPackageListPython(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    this.packageForm.dtPackage = res.data.Data.dataTable;
                    this.updatePackagePager.currentPage =
                        res.data.Data.currentPage;
                    this.updatePackagePager.pageSize = res.data.Data.pageSize;
                    this.updatePackagePager.totalResult =
                        res.data.Data.totalResult;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        exportDataEvent() {
            const $table = this.$refs.xTable1;
            $table.exportData({ type: "csv" });
        },
        keydown(e) {
            if (e.keyCode === 13) {
                this.findData();
            }
        },
        onSelectPubState() {
            //测试发布
            if (this.formInput.formData.PubState === "1") {
                this.formInput.formData.isPro = false;
                if (this.editType == "1") {
                    //新增时校验
                    this.formInput.formRules.fPathPackage[0].required = true;
                    this.formInput.formRules.fPathPpd[0].required = true;
                }

                this.formInput.formRules.fPathResult[0].required = false;
                this.formInput.formRules.ManSingleTime[0].required = false;
                this.formInput.formRules.ManFrequency[0].required = false;
                this.formInput.formRules.ManParticitant[0].required = false;
                this.formInput.formRules.ManYearUse[0].required = false;
                this.formInput.formRules.DevelopTime[0].required = false;
                this.formInput.formRules.RobotType[0].required = false;
                this.formInput.formRules.RobotFrequency[0].required = false;
                this.formInput.formRules.RobotSingleTime[0].required = false;
                this.formInput.formRules.RobotMonthRun[0].required = false;
                this.formInput.formRules.RobotYearUse[0].required = false;
                this.formInput.formRules.ExecBegin[0].required = false;
                this.formInput.formRules.ExecEnd[0].required = false;

                this.formInput.formData.ManSingleTime = 0;
                this.formInput.formData.ManFrequency = 0;
                this.formInput.formData.ManParticitant = 0;
                this.formInput.formData.ManYearUse = 0;
                this.formInput.formData.DevelopTime = 0;
                this.formInput.formData.RobotFrequency = 0;
                this.formInput.formData.RobotSingleTime = 0;
                this.formInput.formData.RobotMonthRun = 0;
                this.formInput.formData.RobotYearUse = 0;
                this.formInput.formData.ExecBegin = "";
                this.formInput.formData.ExecBegin = "";
            } else {
                this.formInput.formData.isPro = true;

                if (this.editType == "1") {
                    this.formInput.formRules.fPathResult[0].required = true;
                    this.formInput.formRules.fPathPackage[0].required = true;
                    this.formInput.formRules.fPathPpd[0].required = true;
                }

                this.formInput.formRules.ManSingleTime[0].required = true;
                this.formInput.formRules.ManFrequency[0].required = true;
                this.formInput.formRules.ManParticitant[0].required = true;
                this.formInput.formRules.ManYearUse[0].required = true;
                this.formInput.formRules.DevelopTime[0].required = true;
                this.formInput.formRules.RobotType[0].required = true;
                this.formInput.formRules.RobotFrequency[0].required = true;
                this.formInput.formRules.RobotSingleTime[0].required = true;
                this.formInput.formRules.RobotMonthRun[0].required = true;
                this.formInput.formRules.RobotYearUse[0].required = true;
                if (this.formInput.formData.RobotType == "2") {
                    //无人值守
                    this.formInput.formRules.ExecBegin[0].required = true;
                    this.formInput.formRules.ExecEnd[0].required = true;
                } else {
                    this.formInput.formRules.ExecBegin[0].required = false;
                    this.formInput.formRules.ExecEnd[0].required = false;
                }
            }
        },
        onSelectRobotType() {
            if (this.formInput.formData.RobotType == "1") {
                //有人值守
                this.formInput.formRules.ExecBegin[0].required = false;
                this.formInput.formRules.ExecEnd[0].required = false;
            } else {
                //无人值守
                this.formInput.formRules.ExecBegin[0].required = true;
                this.formInput.formRules.ExecEnd[0].required = true;
            }
        },
        async insertPackageEvent() {
            const { files } = await VXETable.readFile(false);
            Array.from(files).map((file) => {
                this.formInput.formData.fPathPackage = file.name;
                this.onePackageFile = file;
            });
        },
        async insertPPDEvent() {
            const { files } = await VXETable.readFile(false);
            Array.from(files).map((file) => {
                this.formInput.formData.fPathPpd = file.name;
                this.onePPDFile = file;
            });
        },
        async insertResultEvent() {
            const { files } = await VXETable.readFile(false);
            Array.from(files).map((file) => {
                this.formInput.formData.fPathResult = file.name;
                this.oneResultFile = file;
            });
        },
        //上传发布包
        async insertUpdatePackageEvent() {
            this.packageForm.packageName = "";
            this.packageForm.packageFile = {};
            const { files } = await VXETable.readFile(false);
            Array.from(files).map((file) => {
                this.packageForm.packageName = file.name;
                this.packageForm.packageFile = file;
            });
            let suffix = this.packageForm.packageName
                .toString()
                .substring(
                    this.packageForm.packageName.toString().lastIndexOf(".") + 1
                );
            debugger;
            if (suffix != "rar" && suffix != "RAR") {
                VXETable.modal.alert({
                    content: "发布包类型不正确",
                    status: "error",
                });
                return;
            }

            const params = new FormData();

            params.append("publishId", this.packageForm.selPublishId);
            params.append("file", this.packageForm.packageFile);
            params.append("fileName", this.packageForm.packageName);

            this.$api.publishManageAPI
                .updatePublishPackagePython(params)
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    VXETable.modal.message({
                        content: "上传成功",
                        status: "success",
                    });

                    this.findPackageData();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        downloadFile(type) {
            this.$api.fileManageAPI
                .downloadPublishFilePython(
                    Qs.stringify({
                        publishId: this.formInput.formData.Id,
                        type: type,
                    })
                )
                .then(async (res) => {
                    const contentType = res.headers["content-type"] || "";

                    // 后端返回错误信息
                    if (contentType.includes("application/json")) {
                        const text = await res.data.text();

                        try {
                            const result = JSON.parse(text);

                            VXETable.modal.alert({
                                content: result.Message || "下载失败",
                                status: "error",
                            });
                        } catch (e) {
                            VXETable.modal.alert({
                                content: text,
                                status: "error",
                            });
                        }

                        return;
                    }

                    let fileName = "下载文件";

                    const disposition =
                        res.headers["content-disposition"] ||
                        res.headers["Content-Disposition"];

                    if (disposition) {
                        const utf8Match = disposition.match(
                            /filename\*=UTF-8''([^;]+)/i
                        );

                        const normalMatch =
                            disposition.match(/filename="?([^"]+)"?/i);

                        if (utf8Match && utf8Match[1]) {
                            fileName = decodeURIComponent(utf8Match[1]);
                        } else if (normalMatch && normalMatch[1]) {
                            fileName = decodeURIComponent(normalMatch[1]);
                        }
                    }

                    const blob = new Blob([res.data], {
                        type: contentType || "application/octet-stream",
                    });

                    if (blob.size === 0) {
                        VXETable.modal.alert({
                            content: "文件内容为空",
                            status: "error",
                        });
                        return;
                    }

                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement("a");
                    a.href = url;
                    a.download = fileName;
                    a.style.display = "none";

                    document.body.appendChild(a);

                    a.click();

                    document.body.removeChild(a);

                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.log(error);

                    VXETable.modal.alert({
                        content: "文件下载失败",
                        status: "error",
                    });
                });
        },
        async creatEnv(row) {
            const param = {
                publishId: row.Id,
                editType: "",
                RobotType: "",
                MachineName: "",
                Levele: "",
                IsEncrypt: "",
                userId: this.$store.state.userID,
            };
            const type = await VXETable.modal.confirm(
                "您确定重新生成虚拟环境吗？"
            );
            if (type === "confirm") {
                this.$api.publishManageAPI
                    .createEnv(Qs.stringify(param))
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            this.submitting = false;
                            return;
                        }
                        VXETable.modal.message({
                            content:
                                "已重新提交生成虚拟环境，请等待虚拟创建成功邮件，再执行项目",
                            status: "success",
                        });
                        this.findData();
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        console.log(error);
                    });
            }
        },
        //提交
        async submit() {
            const $rForm = this.$refs.rForm;
            const formErrMap = await $rForm.validate();
            if (formErrMap) {
                this.submitting = false;
                return;
            }
            const type = await VXETable.modal.confirm("您确定要提交该数据吗?");
            const $grid = this.$refs.xTable1;
            if (type === "confirm") {
                const data = this.getModel();

                this.submitting = true;
                this.$api.publishManageAPI
                    .submitPublishPython(data)
                    .then((res) => {
                        if (res.data.Success === false) {
                            VXETable.modal.message({
                                content: res.data.Message,
                                status: "error",
                            });
                            this.submitting = false;
                            return;
                        }
                        VXETable.modal.message({
                            content: "提交成功",
                            status: "success",
                        });
                        this.findData();
                        this.addAuditRecord("0"); //写审核日志
                        this.formInput.isShow = false;
                        this.submitting = false;
                    })
                    .catch((error) => {
                        VXETable.modal.message({
                            content: error,
                            status: "error",
                        });
                        this.submitting = false;
                        console.log(error);
                    });
            }
        },
        updateManYearUse() {
            this.formInput.formData.ManYearUse = (
                this.formInput.formData.ManSingleTime *
                this.formInput.formData.ManFrequency *
                this.formInput.formData.ManParticitant *
                12
            ).toFixed(2);
        },
        updateRobotYearUse() {
            this.formInput.formData.RobotYearUse = (
                this.formInput.formData.RobotMonthRun *
                this.formInput.formData.RobotSingleTime *
                12
            ).toFixed(2);
        },
    },
    mounted() {
        this.bindPC();
        this.findData();
        window.addEventListener("keydown", this.keydown);
    },
    created() {
        this.isShowEditRow = this.$store.state.isAdmin === "1";
    },
    unmounted() {
        window.removeEventListener("keydown", this.keydown, false);
    },
};
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
